<app-nav-bar
  class="navbar pcoded-header navbar-expand-lg navbar-light header-blue"
  *ngIf="!externo"
></app-nav-bar>
<div class="pcoded-main-container">
  <app-menu-nav-bar [modules]="modules" *ngIf="!externo"></app-menu-nav-bar>
  <app-breadcrumb [modules]="modules" *ngIf="!externo"></app-breadcrumb>
  <div
    class="pcoded-content"
    [class.p-0]="externo"
    [ngClass]="{
      container:
        this.nextConfig.layout === 'horizontal' &&
        this.nextConfig.subLayout === 'horizontal-2'
    }"
  >
    <router-outlet></router-outlet>
  </div>
</div>
<app-configuration></app-configuration>
